import { useEffect, useState } from "react";

const NAV_LINKS = [
  { label: "今日瓜榜", href: "#feed" },
  { label: "内幕线索", href: "#insider" },
  { label: "爆料热议", href: "#discussion" },
  { label: "安全投稿", href: "#steps" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-background-50/95 border-b border-background-200" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-20">
          <a href="#home" className="flex items-center gap-2.5 group cursor-pointer">
            <span className="w-9 h-9 md:w-10 md:h-10 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center shadow-none group-hover:rotate-6 transition-transform">
              <i className="ri-fire-fill text-lg md:text-xl"></i>
            </span>
            <span className="font-heading text-xl md:text-2xl font-extrabold tracking-wide text-foreground-950">
              吃瓜投稿
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-8">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="text-sm text-foreground-700 hover:text-primary-600 transition-colors whitespace-nowrap"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#submit"
              className="inline-flex items-center gap-2 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 text-sm px-5 py-2.5 transition-colors whitespace-nowrap"
            >
              <i className="ri-secure-payment-line text-base"></i>
              我要投稿
            </a>
          </nav>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-800 bg-background-100"
            onClick={() => setOpen((v) => !v)}
            aria-label="菜单"
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 pb-4">
          <nav className="flex flex-col gap-1 pt-2">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="px-3 py-3 text-sm text-foreground-800 hover:bg-background-100 rounded-md"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#submit"
              onClick={() => setOpen(false)}
              className="mt-1 px-3 py-3 text-center rounded-full bg-primary-500 text-background-50 text-sm"
            >
              我要投稿
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}